module.exports = __webpack_public_path__ + "static/media/LoginBackground.e7741a88.jpg";